module.exports = __webpack_public_path__ + "img/stock3.cc3b0f4a.png";